import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core'; 

import dayjs from '../../../_utils/dayjs.config';
import { Subscription } from 'rxjs';
import { DarkmodeService } from '../../../_provider/darkmode.service';
import { TimeTicketBundle, ZeitenService } from '../../../_provider/zeiten.service';
import { AddTimePage } from './add-time/add-time.page';
import { TicketEmployee } from '../../../_provider/tickets/ticket.service';
import { SaveService } from '../../../_provider/save.service';
import { HttpFunctionResult } from '../../../_interfaces/HttpFunctionResult';
import { TicketZeit } from '../../../_interfaces/TicketTime';
import { FeedbackService } from 'src/app/_provider/feedback.service';
import { PopoverListItem, PopoverPage } from '../../popover/popover.page';
import { EditArt } from 'src/app/_interfaces/EditArt';
import { Task } from 'src/app/_interfaces/Task';
import { TimeOverviewBasePage } from '../../time-overview/time-overview-base/time-overview-base.page';
import { AuthService } from 'src/app/_provider/auth.service';
import { UserInformationPopover } from 'src/app/_provider/userselect.service';
import { TicketEditService } from 'src/app/_provider/ticket-edit.service';
import { TargetTimeAmount, TimeAmountSelectComponent } from '../ticket-detail-allgemein/time-amount-select/time-amount-select.component';
import { GeneralService } from 'src/app/_provider/general.service';
import { Platform } from '@ionic/angular';

export interface TicketZeitDatum{
  datum: Date
  ticketZeit: TicketZeit[]
}

@Component({
  selector: 'app-ticket-detail-zeiten',
  templateUrl: './ticket-detail-zeiten.component.html',
  styleUrls: ['./ticket-detail-zeiten.component.scss'],
})
export class TicketDetailZeitenComponent implements OnInit {

  @ViewChild("userInformation", {static: false}) userInformationPopup: any
  @ViewChild("timessec", {static: false}) timessec: any

  // public isTimeStarted: boolean = false
  public workstepTimes: TimeTicketBundle[] = []

  public isDarkmode: boolean
  public timeStartError: boolean = false
  public activeTicketNr: string = ""

  public datum: TicketZeitDatum[] = []

  public employeeInformationPosition: UserInformationPopover = {active: false}

  // public startedTime: TicketZeit = {}

  public loadingCount = new Array(4)

  private darkmodeSub: Subscription
  private newTicketSelectedSub: Subscription
  private startExternalSub: Subscription
  private timerSub: Subscription
  private workstepChangedSub: Subscription
  private activeTimeFilterSub: Subscription
  private activeTimeNewListSub: Subscription

  private activeWorkstepId: number = null

  public now: Date = new Date()

  public get externalTimes(): TimeTicketBundle[]{
    return this.ticketSrv.runningExternalTime.filter(ret=>
      this.zeiten.activePersonalTimes.find(apt => apt.time.id == ret.time.id) == undefined && this.zeiten.activeExternalTimes.find(apt => apt.time.id == ret.time.id) == undefined
    )
  }

  constructor(
    public darkmode: DarkmodeService,
    public zeiten: ZeitenService,
    public ticketSrv: TicketEmployee.TicketService,
    private feedback: FeedbackService,
    public authSrv: AuthService,
    private saveSrv: SaveService.Ticket,
    public generalSrv: GeneralService,
    private editSrv: TicketEditService,
    public platform: Platform
    // private routerOutlet: IonRouterOutlet
  ) {

    this.darkmodeSub = darkmode.isDarkMode.subscribe((result: boolean)=>this.isDarkmode = result)

    //Laufende Zeit von ZeitenService updaten jede Sekunde
    this.timerSub = this.zeiten.timer().subscribe(()=> this.now = new Date())

    //Liste der Zeiten updaten nachdem Filter geändert wurde
    this.activeTimeFilterSub = this.zeiten.activeTimeFilter.subscribe((art: EditArt)=>{
      this.sortTimes()
    })

    //Alle Minute kommt neue List vom server mit laufenden Zeiten -> Liste wird geupdatet
    this.zeiten.newActiveTimeList.subscribe(()=>this.sortTimes())

    //Aktive ID des Arbeitsschrittes updaten
    this.workstepChangedSub = this.ticketSrv.newWorkstepSelected.subscribe((workstepId: number)=>{
      if(!workstepId) return
      this.activeWorkstepId = workstepId
    })
  }

  ngOnInit() {}

  private sortTimes(){
    this.workstepTimes =  this.zeiten.getListOfTimes().filter(tt => tt.workspaceId == this.ticketSrv.activeWorkstepId);
    this.zeiten.activePersonalTimes = this.workstepTimes.filter(wt => wt.time.employeeId == +this.authSrv.getUser().id && (this.zeiten.activeTimeFilterValue.id == wt.taskId || this.zeiten.activeTimeFilterValue.id == 0 ))
    this.zeiten.activeExternalTimes = this.workstepTimes.filter(wt => wt.time.employeeId != +this.authSrv.getUser().id && (this.zeiten.activeTimeFilterValue.id == wt.taskId || this.zeiten.activeTimeFilterValue.id == 0 ))
  }

  // private start(): void{
  //   this.workstepTimes = this.zeiten.getListOfTimes().filter(tt => tt.workspaceId == this.activeWorkstepId)
  // }   

  ngOnDestroy(){
    this.darkmodeSub.unsubscribe()
    if(this.newTicketSelectedSub)this.newTicketSelectedSub.unsubscribe()
    if(this.startExternalSub)this.startExternalSub.unsubscribe()
    if(this.timerSub)this.timerSub.unsubscribe()
    if(this.workstepChangedSub) this.workstepChangedSub.unsubscribe()
    if(this.activeTimeFilterSub) this.activeTimeFilterSub.unsubscribe()
    if(this.activeTimeNewListSub) this.activeTimeNewListSub.unsubscribe()
  }

  ngAfterViewInit(){
    this.userInformationPopup.element.nativeElement.addEventListener("mouseenter", ()=>{
      this.employeeInformationPosition.active = true
      this.employeeInformationPosition.animation = false
    })
    this.userInformationPopup.element.nativeElement.addEventListener("mouseleave", ()=>this.employeeInformationPosition.active = false)
  }

  public async startStopTime(isStart: boolean){
    this.feedback.vibrate()
    if (isStart){
      await this.zeiten.startTicketTime(this.ticketSrv.activeWorkstepId, this.ticketSrv.ticket, this.zeiten.activeTimeFilterValue.id == 0 ? null : this.zeiten.activeTimeFilterValue as Task) 
    }else{
      if(this.zeiten.activePersonalTimes.length == 0) return

      //Wenn filter auf Ticketzeit dann das erste stoppen wo taskid 0 ist
      const timeBundle: TimeTicketBundle = this.zeiten.activeTimeFilterValue.id == 0 ? this.zeiten.activePersonalTimes.find(at => at.taskId == 0) : this.zeiten.activePersonalTimes[0]
      timeBundle.time.taskId = timeBundle.taskId
      timeBundle.time.note = ""
      timeBundle.time.timeTo = new Date()
      await this.zeiten.stopTicketTime(timeBundle.time)
    }
  }

  public async addTime(){
    await this.feedback.openModal<TicketZeit>(AddTimePage, {activeTask: this.zeiten.activeTimeFilterValue}, async (result: HttpFunctionResult<TicketZeit>)=>{
      if(!result.success) return
      await this.feedback.updateLoading("Speichern...")
      await this.zeiten.saveTime(result.data)
      await this.feedback.hideLoading()
    })
  }


  public async editTime(time: TicketZeit){

    if(time?.toCalculate == 1) return

    await this.feedback.openModal<TicketZeit>(AddTimePage, {ticketTime: time}, async (result: HttpFunctionResult<TicketZeit>)=>{
      if(!result.success) return

      result.data.id = time.id
      result.data.employeeName = time.employeeName
      const generatetTicketTime: HttpFunctionResult<TicketZeit> = await this.saveSrv.saveTicketTime(result.data, null, null, result.data.taskId)
      if(!generatetTicketTime.success) return

      time.timeFrom = generatetTicketTime.data.timeFrom
      time.timeTo = generatetTicketTime.data.timeTo

      const dateIndex = this.ticketSrv.ticket.timesGrouped.findIndex(d => dayjs(d.datum).isSame(time.timeFrom, "date"))
      const same: TicketZeitDatum = this.ticketSrv.ticket.timesGrouped.find(d=>dayjs(d.datum).isSame(result.data.date, "date"))
      
      if(same != undefined && dayjs(same.datum).isSame(time.date, "date")){
        this.ticketSrv.ticket.timesGrouped[dateIndex].ticketZeit[this.ticketSrv.ticket.timesGrouped[dateIndex].ticketZeit.indexOf(time)] = result.data
      }else{
        this.ticketSrv.ticket.timesGrouped[dateIndex].ticketZeit.splice(this.ticketSrv.ticket.timesGrouped[dateIndex].ticketZeit.indexOf(time), 1)
        if(same) same.ticketZeit.unshift(result.data)
        else this.ticketSrv.ticket.timesGrouped.unshift({
            datum: result.data.date,
            ticketZeit: [result.data],
          })
      }

    })
  }


  public async selectTimeArt(event: any){
    await this.feedback.openPopover<EditArt>(PopoverPage, event, {type: "timeArt"}, (result: HttpFunctionResult<EditArt>)=>{
      if(!result.success) return
      this.zeiten.setActiveTimeFilter(result.data)
    }) 
  }

  public async openTimeModel(){
    await this.feedback.openModal(TimeOverviewBasePage, {ticketId: this.ticketSrv.ticket.id})
  }

  public checkSectionHasTimes(group: TicketZeitDatum): boolean{
    return (group.ticketZeit.filter(tz => tz.taskId == this.zeiten.activeTimeFilterValue.id).length > 0 || this.zeiten.activeTimeFilterValue.id == 0 )
  }

  public get hasNullableTaskIdInPersonal(): boolean{
    return this.zeiten.activePersonalTimes.find(at => at.taskId == 0) ? true : false
  }


  //#region Userinformation Popup
  public userhover(time: TicketZeit, event: any){
    if(time.employeeId == 0) return
    
    let parentSec = this.timessec.nativeElement.getBoundingClientRect();
    

    this.employeeInformationPosition = {
      active: true,
      employee: this.editSrv.employees.find(e => e.id == time.employeeId),
      animation: event.fromElement.classList.contains("distance")? false : true,
      y: (parentSec.bottom - event.y) + event.offsetY - 7,
      x: 0
    }
  }

  public async setTargetTime(event: any){
    let initialBreakpoint: number = Math.floor(100/window.innerHeight * 260) / 100
    await this.feedback.openModal<TargetTimeAmount>(
      TimeAmountSelectComponent,
      {
        initialBreakpoint: initialBreakpoint
      },
      (data: HttpFunctionResult<TargetTimeAmount>)=>{
        // this.feedback.showError(JSON.stringify(data))
      },
      true,
      [initialBreakpoint]
      )
  }


  public userleave(){
    this.employeeInformationPosition.active = false
    this.employeeInformationPosition.animation = false
  }

  public async openOptions(event: Event, time: TicketZeit){
    event.stopPropagation()

    let list: PopoverListItem[] = [ ]

    list.push({id: 1, description: "Bearbeiten", icon: "fa-pen"})
    list.push({id: 2, description: "Intervall umstellen", icon: "fa-timer"})
    
    if(time?.toCalculate == 2) list.push({id: 3, description: "Zu berechnen", icon: "fa-dollar-sign"})
    else list.push({id: 4, description: "Nicht berechnen", icon: "fa-x-mark"}) 
    
    list.push({id: 5, description: "Löschen", icon: "fa-trash", danger: true})
    
    const result: HttpFunctionResult<PopoverListItem> = await this.feedback.showPopover({
      component: PopoverPage,
      event: event,
      componentProps: {list}
    }) 

    if(!result.success) return

    switch(result.data.id){
      case 1: 
        await this.editTime(time)
        break;
      case 2: 
        this.changeIntervall(event, time)
        break;
      case 3: 
        await this.changeToCalculate(time, 0)
        break;
      case 4: 
        await this.changeToCalculate(time, 2)
        break;
      case 5: 
        await this.deleteTime(time)
        break;
    }
  }

  /**
   * Ändern das Intervall für eine bestimmte Zeit
   * @param {Event} event Event zum Öffnen des Popovers
   * @param {TicketZeit} time Zeit, für die das Intervall geändert werden soll
   * @returns 
   */
  private async changeIntervall(event: Event, time: TicketZeit){

    const list: PopoverListItem[] = [
      {id: 0, description: "Zurücksetzen", icon: "fa-timer"}, 
      {id: 1, description: "1 Minute", icon: "fa-timer"},
      {id: 5, description: "5 Minuten", icon: "fa-timer"},
      {id: 10, description: "10 Minuten", icon: "fa-timer"},
      {id: 15, description: "15 Minuten", icon: "fa-timer"},
      {id: 20, description: "20 Minuten", icon: "fa-timer"},
      {id: 30, description: "30 Minuten", icon: "fa-timer"},
      {id: 45, description: "45 Minuten", icon: "fa-timer"},
      {id: 60, description: "1 Stunde", icon: "fa-timer"},
    ]

    const result: HttpFunctionResult<PopoverListItem> = await this.feedback.showPopover({
      event: event,
      component: PopoverPage,
      componentProps: {list}
    })

    if(!result.success) return

    time.customInterval = result.data.id
    const updateResult: HttpFunctionResult<any> = await this.saveSrv.saveTicketTime(time, null, null, time?.taskId)

    if(!updateResult.success) return
    const dateIndex = this.ticketSrv.ticket.timesGrouped.findIndex(d => dayjs(d.datum).isSame(time.timeFrom, "date"))
    this.ticketSrv.ticket.timesGrouped[dateIndex].ticketZeit[this.ticketSrv.ticket.timesGrouped[dateIndex].ticketZeit.indexOf(time)]= {...time}

  }

  /**
   * Löscht eine gespempelte Zeit
   * @param {TicketZeit} time Ticketzeit die gelöscht werden soll
   * @returns 
   */
  private async deleteTime(time: TicketZeit){
    if(!(await this.feedback.confirm("Möchten Sie die Ticketzeit wirklich löschen?", "Löschen", "Abbrechen"))) return

    await this.feedback.showLoading(async () => {
      this.zeiten.deleteTime(time.id, async (result: HttpFunctionResult<any>)=>{
        if(!result.success) return
        await this.ticketSrv.setTimes(this.ticketSrv.activeWorkstepId)
      })
    }, "Zeit Löschen...")
  }

  /**
   * Setzt eine Zeit nicht berechnen oder auf zu berechnen zurück
   * @param {TicketZeit} time Zeit die geändert werden soll
   * @param {number} toCalculate 0,1,2,3
   * @returns 
   */
  private async changeToCalculate(time: TicketZeit, toCalculate: number){
    time.toCalculate = toCalculate
    const updateResult: HttpFunctionResult<any> = await this.saveSrv.saveTicketTime(time, null, null, time?.taskId)

    if(!updateResult.success) return
    const dateIndex = this.ticketSrv.ticket.timesGrouped.findIndex(d => dayjs(d.datum).isSame(time.timeFrom, "date"))
    this.ticketSrv.ticket.timesGrouped[dateIndex].ticketZeit[this.ticketSrv.ticket.timesGrouped[dateIndex].ticketZeit.indexOf(time)]= {...time}
  }


  //#endregion



}
